import React from 'react';

import { makeStyles } from '@material-ui/core';

import LogoWhite from '../../assets/images/logo-white.svg';

const useStyles = makeStyles((theme) => {
  return {
    loginHeader: {
      backgroundColor: '#172B4D',
      height: '100px',
      position: 'relative',
      width: '100%',
      [theme.breakpoints.up('lg')]: {
        height: '120px',
      },
    },
    loginHeaderClippath: {
      backgroundColor: '#172B4D',
      clipPath: 'polygon(50% 100%, 0 0, 100% 0)',
      height: '60px',
      width: '100%',
      [theme.breakpoints.up('md')]: {
        height: '130px',
      },
    },
    loginLogoHeader: {
      bottom: '16px',
      height: 'auto',
      position: 'absolute',
      transform: 'translateX(-50%)',
      width: '219px',
      zIndex: '2',
      [theme.breakpoints.up('md')]: {
        bottom: '0%',
        transform: 'translate(-50%, 100%)',
        width: '358px',
      },
    },
  };
});

export default () => {
  const classes = useStyles();

  return (
    <div>
      {/* Plain header */}
      <div className={classes.loginHeader}>
        <img src={LogoWhite} className={classes.loginLogoHeader} alt="Mediphany" />
      </div>

      {/* Clip Path */}
      <div className={classes.loginHeaderClippath} />
    </div>
  );
};
